import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AuthSSO } from "../../../Auth/screens/AuthSSO";
import { MemberResetPassword } from "../../../Auth/screens/MemberResetPassword";
import { MemberSignIn } from "../../../Auth/screens/MemberSignIn";
import {
  INVITATION_AUTH_PATH,
  InvitationAuthIndex
} from "../../../modules/Invitations";
import { PATH_V3_PERSONS_INVITATION } from "../../../modules/Invitations/paths";
import {
  REQUEST_INVITATION_USER_LINK_PATH,
  RouteRequestLinkIndex
} from "../../../modules/Invitations/routes/RouteRequestLink/RouteRequestLinkIndex";

export const MemberAuthRoutes: React.FC = () => (
  <Switch>
    <Route
      path={REQUEST_INVITATION_USER_LINK_PATH}
      component={RouteRequestLinkIndex}
    />
    <Route path={PATH_V3_PERSONS_INVITATION} component={InvitationAuthIndex} />
    <Route path={INVITATION_AUTH_PATH} component={InvitationAuthIndex} />
    <Redirect from="/register" to="/member/sign-in" />
    <Redirect from="/sign-up" to="/member/sign-in" />

    <Route path="/member/reset-password" component={MemberResetPassword} />

    <Route path="/member/sign-in" component={MemberSignIn} />
    <Route path="/auth/login" component={MemberSignIn} />
    <Route path="/auth/sso" component={AuthSSO} />
    <Redirect from="/sign-in" to="/member/sign-in" />
    <Route
      render={({ location }) => (
        <Redirect
          to={`/member/sign-in#${location.pathname}${location.search}`}
        />
      )}
    />
  </Switch>
);
